import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { setModoTela, ouvirBroker } from "./monitoramentoConsumoActions";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import ContentCard from "../common/template/contentCard";
import Content from "../common/template/content";
import ContentCardBody from "../common/template/contentCardBody";

function MonitoramentoConsumoBroker(props) {
    useEffect(() => {
        const eventSource = props.ouvirBroker();

        return () => {
            // 🔥 fecha conexão ao desmontar componente
            if (eventSource) {
                eventSource.close();
                console.log("❌ Conexão SSE fechada");
            }
        };
    }, []);

    return (
        <Content>
            <ContentCard>
                <ContentCardBody>
                    <Row style={{ width: "100%", justifyContent: "flex-end", paddingBottom: 10 }}>
                        <Grid cols="12 3 3 3">
                            <Button
                                style={{ margin: 0 }}
                                text="Voltar"
                                type={"warning"}
                                icon={"fa fa-chevron-left"}
                                event={() => {
                                    props.setModoTela("lista");
                                }}
                            />
                        </Grid>
                        <Grid cols="12 12 12 12">
                            <h5 style={{ margin: 20, width: "100%", textAlign: "center" }}>Leituras do Broker MQTT</h5>
                        </Grid>
                        <Grid cols="12 12 12 12">
                            {props.dadosBroker.map((dados, index) => (
                                <div key={index} style={{ marginBottom: 15 }}>
                                    <strong>
                                        {dados.tipo} {index == 0 ? <strong style={{ color: "green", marginLeft: 5 }}>(registro mais recente)</strong> : null}
                                    </strong>
                                    <div>Data/Hora: {dados.dataHoraRecebimento}</div>
                                    {dados.numeroUc ? <div>UC: {dados.numeroUc}</div> : null}
                                    <pre>{JSON.stringify(dados.dados, null, 4)}</pre>
                                    <hr />
                                </div>
                            ))}
                        </Grid>
                    </Row>
                </ContentCardBody>
            </ContentCard>
        </Content>
    );
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.monitoramentoConsumo.modoTela,
    dadosBroker: state.monitoramentoConsumo.dadosBroker,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            ouvirBroker,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MonitoramentoConsumoBroker);
